import React from 'react';
import { Leaf, ShieldCheck } from 'lucide-react';
import styles from './BentoSplitHero.module.css';

const BentoSplitHero = ({
  badge,
  scriptTitle,
  boldTitle,
  descriptions,
  features,
  imageLeft,
  imageRight,
  stampLabel = 'Food Grade',
  theme = 'food',
}) => {
  const leadParagraph = descriptions[0];
  const supportLine = descriptions[1];
  const StampIcon = theme === 'industrial' ? ShieldCheck : Leaf;
  const panelClass =
    theme === 'industrial'
      ? `${styles.panel} ${styles.panelIndustrial}`
      : styles.panel;

  return (
    <section
      className={
        theme === 'industrial'
          ? `${styles.heroSection} ${styles.heroIndustrial}`
          : styles.heroSection
      }
    >
      <div className={styles.inner}>
        <div className={panelClass}>
          <div className={styles.copyCol}>
            <span className={styles.badge}>{badge}</span>

            <div className={styles.titleBlock}>
              <span className={styles.eyebrow}>{scriptTitle}</span>
              <h1 className={styles.title}>{boldTitle}</h1>
            </div>

            {leadParagraph && <p className={styles.lead}>{leadParagraph}</p>}
            {supportLine && <p className={styles.support}>{supportLine}</p>}

            {features?.length > 0 && (
              <ul className={styles.featureRow}>
                {features.map((feature, index) => (
                  <li key={index} className={styles.featureChip}>
                    <ShieldCheck size={12} aria-hidden="true" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div className={styles.visualCol}>
            <div className={styles.visualFrame}>
              <img
                className={styles.heroImg}
                src={imageLeft.src}
                alt={imageLeft.alt}
              />
              <div className={styles.floatCard}>
                <img src={imageRight.src} alt={imageRight.alt} />
              </div>
              {stampLabel && (
                <div className={styles.gradeBadge}>
                  <StampIcon size={14} aria-hidden="true" />
                  <span>{stampLabel}</span>
                </div>
              )}
              <span className={styles.orangeEdge} aria-hidden="true" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BentoSplitHero;
